import setListActions from './setListActions';
import setGlobalVar from './setGlobalVar';

const allActions = {
    setListActions,
    setGlobalVar
}

export default allActions